/** Importing firebase */
import dbRef from "../../firebase/firebaseInit";

/** Importing Sheetjs | XLSX */
import XLSX from "xlsx";

const days = {
  Sat: "Saturday",
  Sun: "Sunday",
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednedday",
  Thu: "Thursday",
  Fri: "Friday"
};

const state = {
  exportedJsonObject: undefined,
  tempObject: {},
  formatted: {},
  error: ""
};

const getters = {
  t_allStudents: state => state.students,
  error: state => state.error,
  getFormatted: state => state.formatted
};

const actions = {
  onExcelSelected({ commit }, event) {
    let fileName = event.target.files[0].name;
    let splitted = fileName.split("."),
      fileExtension = splitted[splitted.length - 1];
    if (fileExtension !== "xlsx") {
      commit("setFileTypeError", "Please select a valid EXCEL file");
    } else {
      extras.setInputFileName(fileName);
      var reader = new FileReader();
      reader.readAsArrayBuffer(event.target.files[0]);
      reader.onload = function() {
        let exportedJsonObject = {};
        var arrayBuffer = this.result;
        let data = new Uint8Array(arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i)
          arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        workbook.SheetNames.forEach(sheetName => {
          var worksheet = workbook.Sheets[sheetName];
          exportedJsonObject[sheetName] = XLSX.utils.sheet_to_json(worksheet, {
            raw: true
          });
        });
        commit("setExportedJson", exportedJsonObject);
      };
    }
  }
};

const mutations = {
  formatToRoutine(state) {
    let formatted = {
      routines: {},
      emptyRooms: {},
      labs: {},
      initials: []
    };
    let data = state.exportedJsonObject;

    for (let daySlot in data) {
      if (daySlot !== "Labs") {
        data[daySlot].forEach(routine => {
          let splitted = daySlot.split("_");
          let day = splitted[0];
          let slot = splitted[1];

          if (
            routine.Teacher &&
            !formatted.initials.includes(routine.Teacher)
          ) {
            formatted.initials.push(routine.Teacher);
          }
          if (routine.Course) {
            if (formatted.routines[day]) {
              if (formatted.routines[day][slot]) {
                formatted.routines[day][slot].push(routine);
              } else {
                formatted.routines[day][slot] = [routine];
              }
            } else {
              formatted.routines[day] = {};
              formatted.routines[day][slot] = [routine];
            }
            /** Empty Room */
          } else {
            if (formatted.emptyRooms[day]) {
              if (formatted.emptyRooms[day][slot]) {
                formatted.emptyRooms[day][slot].push(routine);
              } else {
                formatted.emptyRooms[day][slot] = [routine];
              }
            } else {
              formatted.emptyRooms[day] = {};
              formatted.emptyRooms[day][slot] = [routine];
            }
          }
        });
      } else {
        data.Labs.forEach(lab => {
          if (lab.Teacher && !formatted.initials.includes(lab.Teacher)) {
            formatted.initials.push(lab.Teacher);
          }
        });
        formatted.labs = data.Labs;
      }
    }
    mutations.setExportedJson(state, formatted);
  },
  exportExcelExported: state => {
    let object = state.exportedJsonObject;
    extras.exportToJson(object);
  },
  normalizeToHighlighted: state => {
    let highlighted = extras.syntaxHighlight(
      JSON.stringify(state.exportedJsonObject, null, 4)
    );
    extras.setPreHighlighted(highlighted);
  },
  minifyExcelExported: state => {
    extras.setPreHighlighted("");
    let minified = JSON.stringify(state.exportedJsonObject, null, 0);
    extras.setPreHighlighted(minified);
  },
  clearExcelExported: () => {
    extras.setPreHighlighted("");
    extras.setInputFileName("Choose an exel file");
  },
  setFileTypeError: (state, error) => {
    state.error = error;
    setTimeout(() => {
      state.error = "";
    }, 4000);
  },
  setExportedJson: (state, data) => {
    state.exportedJsonObject = data;
    let highlighted = extras.syntaxHighlight(JSON.stringify(data, null, 4));
    extras.setPreHighlighted(highlighted);
  },
  async reformatStudentsData() {
    let students = [];
    let res = await dbRef.collection("Students").get();
    res.forEach(doc => students.push(doc.data()));
    let reStudents = {};
    students.forEach(stud => {
      let data = {
        lastVisited: new Date(stud.LastVisited.seconds * 1000),
        createdAt: new Date(stud.CreatedAt.seconds * 1000)
      };
      reStudents[stud.ID] = data;
    });
    let studRef = dbRef.collection("aStudents").doc("_2019");
    studRef.set(reStudents);
  },
  async reformatVisitorsData() {
    let reForm = {};
    let res = await dbRef.collection("UsageHistory").get();
    res.forEach(doc => {
      let visitor = doc.data();
      let data = {
        lastVisited: new Date(visitor.last_visited.seconds * 1000),
        createdAt: new Date(visitor.first_visited.seconds * 1000)
      };
      reForm[doc.id] = data;
    });
    dbRef
      .collection("aUsages")
      .doc("_2019")
      .set(reForm);
  }
};

const extras = {
  getFilteredRoutine(routines) {
    for (let day in routines) {
      for (let slot in routines[day]) {
        routines[day][slot] = routines[day][slot].filter(
          routine => routine.Course
        );
      }
    }
    return routines;
  },
  getEmptyRooms(routines) {
    let emptyRooms = {};
    days.forEach(day => (emptyRooms[day.full] = []));
    for (let day in routines) {
      for (let slot in routines[day]) {
        routines[day][slot].forEach(routine => {
          if (!routine.Course) {
            if (emptyRooms[day][slot]) {
              emptyRooms[day][slot].push(routine);
            } else {
              emptyRooms[day][slot] = [routine];
            }
          }
        });
      }
    }
    return emptyRooms;
  },
  setInputFileName(name) {
    document.getElementById("customFileLabel").innerHTML = name;
  },
  setPreHighlighted(data) {
    let pre = document.getElementById("pre");
    pre.innerHTML = data;
  },
  syntaxHighlight(json) {
    json = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      function(match) {
        var cls = "number";
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = "key";
          } else {
            cls = "string";
          }
        } else if (/true|false/.test(match)) {
          cls = "boolean";
        } else if (/null/.test(match)) {
          cls = "null";
        }
        return '<span class="' + cls + '">' + match + "</span>";
      }
    );
  },
  exportToJson(json) {
    let dataStr = JSON.stringify(json);
    let dataUri =
      "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);
    let exportFileDefaultName = "data.json";
    let linkElement = document.createElement("a");
    linkElement.setAttribute("href", dataUri);
    linkElement.setAttribute("download", exportFileDefaultName);
    linkElement.click();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
